<template>
<div class="position-relative">
    <div class="position-relative" v-if="product.available_for_order">
        <div class="quantity-button">
            <div class="form-submit text-center mb-4 pb-3" v-if="lang == 'it'">
                <a @click="addToCart" class="goto cursor-pointer" href="javascript:void(0)" :title="$root.translateString('buy')" v-text="$root.translateString('buy')"></a>
            </div>
        </div>
        <p class="added-to-cart mt-3 d-inline-block d-lg-none text-center w-100" v-if="added_to_cart">{{$root.translateString('added_to_cart')}}</p>
    </div>
    <div class="position-relative" v-else>
        <div class="prodotto-quantity no-before">
            <p class="text-white mb-0 text-white mb-0 text-center text-lg-left w-100">- {{$root.translateString('not_available')}} -</p>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: ['product', 'lang'],
        data() {
            return {
                main_selector: 'year',
                default_format: 'bottiglia',
                selected_code: '',
                selected_format: '',
                selected_year: '',
                combinations: {
                },
                formats: [],
                years: [],
                buy: {
                    type: 'product',
                    id: null,
                    qty: 1
                },
                added_to_cart: false,
            }
        },
        created() {
            if(this.product.title)

                this.buy.id = this.product.id;

            this.combinations[0] = {
                code: 'unique',
                price: this.product.price,
                attributes: {}

            };
        },
        methods: {
            addToCart()
            {
                this.buy.combination = this.combinations[0];
                axios.post('/api/cart/add', this.buy)
                .then(response => {
                    if(response.data.status === true) {

                        fbq('track', 'AddToCart',
                            {
                                value: parseFloat(this.price),
                                currency: 'EUR',
                                contents: [
                                    {
                                        id: this.product.name,
                                        quantity: this.buy.qty
                                    },
                                ],
                                content_type: 'product',
                                content_name: this.product.name
                            }
                        );
                        let buy_qty_memo = this.buy.qty
                        this.$eventHub.$emit('cart.added', {
                            count: response.data.count,
                            specific_count: buy_qty_memo,
                            product_id: this.product.id
                        });
                        this.buy.qty = 1;
                        this.added_to_cart = true;
                        setTimeout(() => {
                          // this.added_to_cart = false;
                        }, 4000);
                    }

                })
                .catch(err => {
                    //console.log('Error');
                });
            },
        },
        computed: {
            price() {
                let base = this.combinations[this.selected_code].price;
                let qty = this.buy.qty;

                return this.$root.currencyDisplaySimple(base * qty);
            }
        }
    }
</script>
